















declare var window: any;
import { Component, Vue, Prop } from 'vue-property-decorator';
import JobHistoryDetails from '@/components/JobHistoryDetails.vue';
import NewJobHistoryDetails from '@/components/NewJobHistoryDetails.vue';
import { vxm } from '@/store.vuex';
@Component({
  components: {
    JobHistoryDetails,
    NewJobHistoryDetails,
  },
})
export default class WorkExperience extends Vue {
  @Prop() bus;
  @Prop () isRequiredStep;
  @Prop () minimumEntries;
  @Prop () isLastStep;
  disableNext(val) {
    this.$emit('disable-next-button', val);
  }
  async goToNext() {
    await vxm.users.validateMandatorySteps();
    if (vxm.users.MissedMandatorySteps.length && this.isLastStep) {
           this.$emit('missed-mandatory', vxm.users.MissedMandatorySteps);
    }else{
        this.$emit('go-to-next');
    }
  }
  get jobHistoryComponent() {
    return vxm.configs.getGlobalConfigValue('ENABLE_USER_PROFILE_V2')
      ? 'NewJobHistoryDetails'
      : 'JobHistoryDetails';
  }

}
